import React from 'react';
//Helpers
import { UnlimitedCard } from 'components/unlimitedCard/card';

export function Message({ children, className = '' }) {

  return (
    <div>
      <UnlimitedCard className={`mb-14 w-1/2 mx-auto ${className}`} id="14">
        <div className="text-center">{children}</div>
      </UnlimitedCard>
    </div>
  );
}

export default Message;
